// src/utils/passkey.js

// Veriyi Base64 formatına çeviren yardımcılar
const toBuffer = (txt) => Uint8Array.from(atob(txt), c => c.charCodeAt(0));
const toString = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));

// 1. CİHAZ KAYIT (REGISTER) FONKSİYONU
export const registerPasskey = async (username) => {
  // Rastgele bir "Challenge" oluştur (Güvenlik sorusu gibi)
  const challenge = new Uint8Array(32);
  window.crypto.getRandomValues(challenge);

  // Tarayıcıya "Yeni bir anahtar oluştur" diyoruz
  const publicKey = {
    challenge: challenge,
    rp: { name: "UKBA Kasa", id: window.location.hostname },
    user: {
      id: Uint8Array.from(username, c => c.charCodeAt(0)),
      name: username,
      displayName: username,
    },
    pubKeyCredParams: [{ alg: -7, type: "public-key" }, { alg: -257, type: "public-key" }],
    authenticatorSelection: { authenticatorAttachment: "platform" }, // Cihazın kendi sensörünü kullan (FaceID/TouchID)
    timeout: 60000,
    attestation: "direct"
  };

  try {
    const credential = await navigator.credentials.create({ publicKey });
    // Oluşan anahtarın ID'sini alıp geri döndürüyoruz (Veritabanına kaydetmek için)
    return toString(credential.rawId);
  } catch (err) {
    console.error("Passkey Oluşturma Hatası:", err);
    throw err;
  }
};

// 2. GİRİŞ DOĞRULAMA (LOGIN) FONKSİYONU
export const authenticatePasskey = async (savedCredentialIds) => {
  // Rastgele Challenge
  const challenge = new Uint8Array(32);
  window.crypto.getRandomValues(challenge);

  // Veritabanındaki kayıtlı ID'leri tarayıcının anlayacağı dile çevir
  const allowCredentials = savedCredentialIds.map(id => ({
    id: toBuffer(id),
    type: 'public-key',
    transports: ['internal']
  }));

  const publicKey = {
    challenge,
    allowCredentials,
    timeout: 60000,
    userVerification: "required" // Mutlaka parmak izi/yüz onayı iste
  };

  try {
    // Tarayıcıya "Bu anahtarlardan biriyle kilidi aç" diyoruz
    const assertion = await navigator.credentials.get({ publicKey });
    // Hangi anahtarla açıldığını geri döndür
    return toString(assertion.rawId);
  } catch (err) {
    console.error("Passkey Giriş Hatası:", err);
    throw err;
  }
};